// src/services/analyticsService.js
// First-party usage tracking for VU Connect. Records app-open events against the
// authenticated Drupal user via /vu-connect/api/analytics/track.

const SESSION_KEY = 'vu_session_id';
const OPEN_TRACKED_KEY = 'vu_app_open_tracked';

// Stable per-session id used to group events server-side.
function getSessionId() {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

// 'standalone' when launched from an installed PWA, otherwise 'browser'.
function getDisplayMode() {
  const standalone =
    (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
    window.navigator.standalone === true;
  return standalone ? 'standalone' : 'browser';
}

function getPlatform() {
  const ua = window.navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'desktop';
}

// Drupal requires a CSRF token for unsafe (POST) requests. Fetch once and cache.
let csrfTokenPromise = null;
function getCsrfToken() {
  if (!csrfTokenPromise) {
    csrfTokenPromise = fetch('/session/token', { credentials: 'include' })
      .then((res) => (res.ok ? res.text() : null))
      .catch(() => null);
  }
  return csrfTokenPromise;
}

async function trackEvent(eventType, path = window.location.pathname) {
  try {
    const token = await getCsrfToken();
    if (!token) return;
    await fetch('/vu-connect/api/analytics/track', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token,
      },
      body: JSON.stringify({
        event_type: eventType,
        session_id: getSessionId(),
        display_mode: getDisplayMode(),
        platform: getPlatform(),
        path,
      }),
    });
  } catch (err) {
    // Analytics is best-effort; never disrupt the app.
  }
}

// Records one app-open per browser session.
export function trackAppOpen() {
  if (sessionStorage.getItem(OPEN_TRACKED_KEY)) return;
  sessionStorage.setItem(OPEN_TRACKED_KEY, '1');
  trackEvent('app_open');
}
